import { HugeiconsIcon } from "@hugeicons/react";
import { MoneyRemove02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { VerificationNames } from "shared/types";
import { ReportHeader } from "views/applications-id-report/components/ReportHeader";

/**
 * Purchase-application report when the applicant chose "I don't need
 * financing" on the lender step (PLT-728). The verification is finished on
 * the BE but carries no report, so instead of the generic "Report is not
 * available" fallback staff see the applicant's choice and when it was made.
 */
export const DeclinedFinancingView = ({
  declinedAt
}: {
  declinedAt?: string;
}) => (
  <>
    <ReportHeader
      title="Purchase application"
      name={VerificationNames.BoomFinanceVerification}
      reportDate={declinedAt}
      reportDateText="Opted out on"
      hidePrint
    />

    <div className="flex w-full items-center justify-center py-16">
      <div className="flex max-w-md flex-col items-center gap-6 p-6 text-center">
        <div className="rounded-full bg-alpha-20 p-5 text-content-400">
          <HugeiconsIcon icon={MoneyRemove02Icon} size={24} />
        </div>
        <div className="space-y-2">
          <h2 className="text-base font-bold text-content-1000">
            Applicant opted out of financing
          </h2>
          <p className="text-sm font-medium text-content-300">
            The applicant selected &quot;I don&apos;t need financing&quot; and
            skipped the purchase application. No lenders were contacted.
          </p>
        </div>
      </div>
    </div>
  </>
);
